import React, { useEffect, useState } from 'react'
import { MarketersListVM } from '../../Structure/ViewModels/Admin/MarketersListVM'
import { Accordion, Col, Row } from 'react-bootstrap'
import { Router } from '../../Structure/Handlers/Router'
import MarketerDetails from '../Marketer/MarketerDetails'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPerson } from '@fortawesome/free-solid-svg-icons'
import AddNewMarketer from './AddNewMarketer'
import Search from '../Utilities/Search'
import { Globals } from '../../Structure/Globals/GlobalObs'

const MarketersList = () => {
    const [vm , setVm] = useState<{viewModel:MarketersListVM}>({viewModel:new MarketersListVM()})
    const control = vm.viewModel
    useEffect(()=>{
        control.subscribeUpdate(setVm)
        control.load()
    },[])

    const [selectedButton , setSelectedButton]= useState<string>('0')

    const scroll = ()=>{
        document.getElementById('search-form-marketers')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start',   
            inline: 'nearest'  
          })
    }


  return (
    <div className='d-flex flex-column py-3'>
        <div className=' py-3 d-flex flex-wrap justify-content-between'>
            <div className='py-2'>
                <button className='button-I btn-cl-I px-5 py-2' onClick={()=>Router.OpenNormalPage(<AddNewMarketer/>)}>اضافة مسوق جديد</button>
            </div>
            <div className='d-flex py-2'>
                <Search id='marketers' hasNoSelect onSearch={a=>{ control.load(a); scroll(); }}/>
            </div>
        </div>
            {
            control.ShowWithMessege(
                <Accordion defaultActiveKey={selectedButton} className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}}>
                    <Accordion.Item eventKey='1' className='w-100 rounded-0' style={{outline:'none' , borderRadius:'0px'}} onClick={()=>setSelectedButton(selectedButton=='0'?'1':'0')}>
                    <Accordion.Button className='border-0 border-bottom-0' style={{outline:'none', border:'none' , borderRadius:'0px', boxShadow:'none'}}>
                          <h5 className='px-3'>المسوقين</h5>
                    </Accordion.Button>
                    <Accordion.Body className=' overflow-y-auto'  style={{maxHeight:'450px'}}>
                      <Row>
                        <div className='d-flex'>
                            <div className='d-flex p-2 c-pointer'>
                                <input type="checkbox"
                                    id="active" checked={control.status=='active'}
                                    onChange={a=>control.status=a.target.checked?'active':'inActive'} 
                                />
                                <label htmlFor="active" className='px-2'>النشطين</label>
                            </div>
                        </div>
                        {
                            control.List.filter(a=>a.status==control.status).map((item,index)=>(
                                <Col key={index} className='px-3 py-2 h-100' sm={6} md={4} xl={3}>
                                    <Row className='py-4 box-shadow-II rounded-2 w-100 m-0'>
                                        <div className='d-flex flex-wrap px-3 justify-content-between c-pointer'  onClick={()=>{ if(Globals.auth.User){ if(Globals.auth.User.permissions.some(a=>a.id=='7')) Router.OpenNormalPage(<MarketerDetails id={item.id}/>) } } }>
                                            <div className='d-flex flex-wrap '>
                                                <div className='txt-color-I px-3 my-auto fw-bold w-100'>
                                                    {item.name}
                                                </div>
                                                <div className='txt-color-I px-3 my-auto fw-bold justify-content-start d-flex w-100'>
                                                    <FontAwesomeIcon icon={faPerson} className='p-3 pe-0' />
                                                    <span className='my-auto'>{item.trainees_count}</span>
                                                </div>
                                                <div className='text-success px-3 my-auto fw-bold w-100'>
                                                    {item.commission}%
                                                </div>
                                            </div>
                                        </div>
                                    </Row>
                                </Col>
                            ))
                        }
                          
                      </Row>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
            )
        }
    </div>
  )
}

export default MarketersList
